import {useContext} from 'react';
import {GlobalContext} from '../../../../../utilities/GlobalContext';
import signUp from '../../../../../api/auth/signUp';
import slideSystem from '../../slideSystem';
import Slide1 from './Slide1';
import Slide2 from './Slide2';

function ExportSlides() {
	let serverOrigin = useContext(GlobalContext).serverOrigin;
	let user = useContext(GlobalContext).user;
	let setUser = useContext(GlobalContext).setUser;
	let slides = [Slide1, Slide2];
	let mainSlides = slideSystem(slides, {
		done: done,
		next: next,
	});

	return mainSlides;

	function next(userFrag, options = {}) {
		let userBuffer = user || {};
		for (let property in userFrag) {
			userBuffer[property] = userFrag[property];
			setUser(userBuffer);
		}
		if (options.createUser) {
			let user = cleanUser(userBuffer);
			signUp(user, setUser, serverOrigin)
				.then(() => {
					alert('Account created successfully');
					window.location.href = '/home';
				})
				.catch(() => {
					alert('Failed to create account');
					window.location.href = '/signup';
				});
		}
	}
	function done() {}
	function cleanUser(inUser) {
		let user = {
			name: {
				first: inUser.name.first || 'error',
				last: inUser.name.last || null,
			},
			email: inUser.email || 'error',
		};

		user.a1 = inUser.a1 || null;
		user.a2 = inUser.a2 || null;
		user.a3 = inUser.a3 || null;
		user.a4 = inUser.a4 || null;
		user.age = inUser.age || null;
		user.listOfGoals = inUser.listOfGoals || null;

		return user;
	}
}

export default ExportSlides;
